import { InputAdornment, TextField, Typography } from '@mui/material'
import { useState } from 'react'
import { Modal } from '../../../../customComponents/Modal'
import { toast } from 'react-toastify'

interface Props {
  title: string
  attendees: string
  budget: string
  onSave: (attendees: number, budget: number | null) => void
  onCancel: () => void
}

export function AttendancePlanTrackingModal (props: Props): JSX.Element {
  const [attendees, setAttendees] = useState<string>(props.attendees)
  const [budget, setBudget] = useState<string>(props.budget)

  const saveChange = (): void => {
    const attendeeNumber = Number(attendees)
    if (attendees == null || isNaN(attendeeNumber) || attendeeNumber < 0) {
      toast.error('Please enter a valid number for attendees')
      return
    }

    if (budget !== '') {
      const budgetNumber = Number(budget)
      if (isNaN(budgetNumber) || budgetNumber < 0) {
        toast.error('Please enter a valid number for budget')
        return
      }
    }

    props.onSave(attendeeNumber, budget === '' ? null : Number(budget))
  }

  return <Modal
    title={props.title}
    open={true}
    width='450px'
    data-testid={`${props.title}-modal`}
    onClose={props.onCancel}
    onConfirm={saveChange}
    buttonClassName='modal-button'
    confirmButtonText='Save'
    confirmButtonClassName='modal-confirm-button'
    cancelButtonText='Cancel'
    bodyContent={ <>
      <Typography variant='h5' sx={{ my: '.5em' }}>Attendance</Typography>
      <Typography variant='body1' sx={{ mb: '.5em' }}>How many people were funded to attend?</Typography>
      <TextField
        name='attendees'
        label='Enter Number'
        value={attendees}
        data-testid='attendees'
        onChange={e => { setAttendees(e.target.value) }}
        variant='filled'
        required
        error={attendees == null}
      />
      <Typography variant='h5' sx={{ my: '.5em' }}>Budget</Typography>
      <><Typography variant='body1'>How much funding was actually used?</Typography><Typography variant='body2' sx={{ fontStyle: 'italic' }}>Optional</Typography></>
      <TextField
        sx={{ mt: '.75em', width: '250px' }}
        onChange={(e) => { setBudget(e.target.value) }}
        label='Enter Amount'
        data-testid='actualBudgetAmount'
        InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }}
        name='actualBudgetAmount'
        variant='filled'
        value={budget}
      />
    </>
    }
  />
}
